// Surface tokens borrowed from HeroUI's default light theme (zinc scale,
// small shadow, medium/large radii) so the extraction pages read as HeroUI
// surfaces while text, buttons, and brand colors stay chroma.
export const heroSurface = {
  radiusSmall: 8,
  radiusMedium: 12,
  radiusLarge: 14,
  background: '#fff',
  muted: '#f4f4f5',
  mutedHover: '#e4e4e7',
  border: '#e4e4e7',
  textMuted: '#71717a',
  shadowSmall:
    '0 0 5px 0 rgba(0, 0, 0, 0.02), 0 2px 10px 0 rgba(0, 0, 0, 0.06), 0 0 1px 0 rgba(0, 0, 0, 0.3)',
  transition: '150ms ease',
};

// Every gap and inset between elements on the extraction pages is one of
// these: `regular` between blocks and around panels, `tight` between inline
// pieces. Nested insets add up to `regular` (e.g. card `tight` + row `tight`).
export const heroSpace = {
  tight: 6,
  regular: 12,
};

export const heroChipStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: heroSpace.tight,
  height: 24,
  padding: '0 8px',
  borderRadius: 999,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  fontWeight: 500,
  whiteSpace: 'nowrap' as const,
};

export const heroChipTone = {
  warning: { backgroundColor: 'rgba(245, 165, 36, 0.2)', color: '#936316' },
  success: { backgroundColor: 'rgba(23, 201, 100, 0.2)', color: '#0e793c' },
  danger: { backgroundColor: 'rgba(195, 21, 51, 0.12)', color: '#b40027' },
  neutral: { backgroundColor: heroSurface.muted, color: '#3f3f46' },
};

export const heroSectionLabelStyle = {
  margin: 0,
  color: heroSurface.textMuted,
  fontSize: '0.75rem',
  fontWeight: 600,
  letterSpacing: '0.02em',
  textTransform: 'uppercase' as const,
};
